/* Etiqueta chica de estado o de dato: radio 6, 12px semibold. Píldora sólo con `shape="pill"`, el marcador
   chiquito pegado a un nombre ("vos"); una píldora clickeable es un Chip. */
.badge {
  --_h: 28px;
  --_px: 10px;
  --_dot: currentColor;

  display: inline-flex;
  align-items: center;
  gap: var(--s-3);
  height: var(--_h);
  padding: 0 var(--_px);
  border-radius: var(--r-badge);
  border: var(--bw-hair) solid transparent;
  background: var(--surface-sunken);
  color: var(--text-muted);
  font-family: var(--font-body);
  font-size: var(--fs-2xs);
  font-weight: var(--fw-semibold);
  line-height: 1;
  white-space: nowrap;
}
.badge[data-size="sm"] {
  --_h: 22px;
  --_px: var(--s-4);
  font-size: var(--fs-3xs);
}
.badge[data-dot] {
  padding-left: var(--s-4);
}
.badge[data-shape="pill"] {
  --_h: 20px;
  --_px: 7px;
  border-radius: var(--r-full);
  font-size: var(--fs-3xs);
}
/* Clickeable (`as="button"`): mismo dibujo, cursor de mano, un toque más oscuro al pasar y el anillo de foco. */
.badge[data-interactive] {
  appearance: none;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: filter var(--dur-fast) var(--ease-standard);
}
@media (hover: hover) {
  .badge[data-interactive]:hover:enabled {
    filter: brightness(0.97);
  }
}
.badge[data-interactive]:focus-visible {
  outline: none;
  box-shadow: var(--ring-focus);
}
.badge[data-interactive]:disabled {
  cursor: not-allowed;
  opacity: var(--action-disabled-opacity);
}
.flecha {
  opacity: 0.7;
}
.punto {
  width: var(--s-3);
  height: var(--s-3);
  border-radius: var(--r-full);
  background: var(--_dot);
}

/* Los estados sobre blanco siguen la regla de los tokens: 50 de fondo, 200 de borde, 600 el punto, 700 el texto. */
.badge[data-tone="neutral"] {
  --_dot: var(--text-subtle);
  border-color: var(--border-hair);
}
.badge[data-tone="outline"] {
  --_dot: var(--border-strong);
  background: var(--surface-card);
  border-color: var(--border-strong);
  color: var(--text-body);
}
.badge[data-tone="brand"] {
  background: var(--surface-brand-soft);
  border-color: var(--border-brand-soft);
  color: var(--text-brand);
}
.badge[data-tone="accent"] {
  background: var(--surface-accent-soft);
  color: var(--text-accent);
}
/* Cian sólido con tinta: "Nuevo". El único cian pleno que admite el texto encima, porque el texto es ink. */
.badge[data-tone="highlight"] {
  background: var(--surface-accent);
  color: var(--brand-ink);
}
.badge[data-tone="success"] {
  --_dot: var(--status-success);
  background: var(--status-success-bg);
  border-color: var(--status-success-border);
  color: var(--text-success);
}
.badge[data-tone="warning"] {
  --_dot: var(--status-warning);
  background: var(--status-warning-bg);
  border-color: var(--status-warning-border);
  color: var(--text-warning);
}
.badge[data-tone="danger"] {
  --_dot: var(--status-danger);
  background: var(--status-danger-bg);
  border-color: var(--status-danger-border);
  color: var(--text-danger);
}
/* Tinta con texto blanco: el precio sobre la foto. */
.badge[data-tone="inverse"] {
  background: var(--surface-inverse);
  color: var(--text-inverse);
}
/* Sobre fotografía: vidrio oscuro con hairline blanca. Lleva icono (m², habitaciones, baños). */
.badge[data-tone="overlay"] {
  background: var(--surface-overlay);
  border-color: var(--border-inverse);
  color: var(--brand-white);
  font-weight: var(--fw-medium);
  font-size: var(--fs-3xs);
  -webkit-backdrop-filter: blur(6px);
  backdrop-filter: blur(6px);
}
